export default __webpack_public_path__ + "static/media/switch1.8b886f8c.svg";